import { Flex } from '@chakra-ui/react'
import type { ComponentProps, ReactNode } from 'react'

import { SibHeader } from './SibHeader'
import { PageContainer } from './PageContainer'

type SibPageShellProps = ComponentProps<typeof SibHeader> & {
  children: ReactNode
}

export function SibPageShell({ children, ...headerProps }: SibPageShellProps) {
  return (
    <Flex minH="100dvh" direction="column" bg="bg">
      <SibHeader {...headerProps} />
      <PageContainer variant="default">{children}</PageContainer>
    </Flex>
  )
}
